module.exports = __webpack_public_path__ + "img/program-fetish_talk.d4b2c712.jpg";